import * as graphql from 'generated/graphql';
import { SharedFields } from '../ProductConfiguration';

import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'clientID') {
		return {
			title: 'Client ID',
			description: 'Vul het Client ID in van de Cobra omgeving.',
		};
	}

	if (key === 'clientSecret') {
		return {
			title: 'Client Secret',
			description: 'Vul de Client Secret in die behoort bij het hierboven ingevoerde Client ID.',
		};
	}

	if (key === 'syncSubstituteManagers') {
		return {
			title: 'Vervangende manager synchroniseren',
			description: 'Wil je de vervangende manager (indien aanwezig) synchroniseren?',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

export default function SDWorx() {
	return (
		<ProductLayout
			id="cobra"
			type={graphql.ConnectorType.Cobra}
			description={undefined}
			headerImageURL=""
			translate={translate}
			pricingLink="https://go.sdworx.com/freemium-inschrijven"
		/>
	);
}

export function SDWorxTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="cobra"
			title="SDWorx Cobra"
			description="HRM & Salaris. For life. For work."
			logoImageURL="https://assets.ontreams.com/marketplace/sdworx.png"
			selected={props.selected}
		/>
	);
}
